import { ReportRecord } from '../../../models/report.model';
import { getFloor, getSelectedAvailability, getTenants } from './common';
import { TemplateFieldsDisplayFn } from '../../../models/template.model';

export function STACKINGPLAN_FIELDS(): TemplateFieldsDisplayFn {
  return {
    701: {
      displayFn: (record: ReportRecord) => {
        return getFloor(record, 0);
      },
    },
    702: {
      displayFn: (record: ReportRecord) => {
        return getTenants(record, 0);
      },
    },
    703: {
      displayFn: (record: ReportRecord) => {
        return getSelectedAvailability(record, 0);
      },
    },
    704: {
      displayFn: (record: ReportRecord) => {
        return getFloor(record, 1);
      },
    },
    705: {
      displayFn: (record: ReportRecord) => {
        return getTenants(record, 1);
      },
    },
    706: {
      displayFn: (record: ReportRecord) => {
        return getSelectedAvailability(record, 1);
      },
    },
    707: {
      displayFn: (record: ReportRecord) => {
        return getFloor(record, 2);
      },
    },
    708: {
      displayFn: (record: ReportRecord) => {
        return getTenants(record, 2);
      },
    },
    709: {
      displayFn: (record: ReportRecord) => {
        return getSelectedAvailability(record, 2);
      },
    },
    710: {
      displayFn: (record: ReportRecord) => {
        return getFloor(record, 3);
      },
    },
    711: {
      displayFn: (record: ReportRecord) => {
        return getTenants(record, 3);
      },
    },
    712: {
      displayFn: (record: ReportRecord) => {
        return getSelectedAvailability(record, 3);
      },
    },
    713: {
      displayFn: (record: ReportRecord) => {
        return getFloor(record, 4);
      },
    },
    714: {
      displayFn: (record: ReportRecord) => {
        return getTenants(record, 4);
      },
    },
    715: {
      displayFn: (record: ReportRecord) => {
        return getSelectedAvailability(record, 4);
      },
    },
    716: {
      displayFn: (record: ReportRecord) => {
        return getFloor(record, 5);
      },
    },
    717: {
      displayFn: (record: ReportRecord) => {
        return getTenants(record, 5);
      },
    },
    718: {
      displayFn: (record: ReportRecord) => {
        return getSelectedAvailability(record, 5);
      },
    },
    719: {
      displayFn: (record: ReportRecord) => {
        return getFloor(record, 6);
      },
    },
    720: {
      displayFn: (record: ReportRecord) => {
        return getTenants(record, 6);
      },
    },
    721: {
      displayFn: (record: ReportRecord) => {
        return getSelectedAvailability(record, 6);
      },
    },
    722: {
      displayFn: (record: ReportRecord) => {
        return getFloor(record, 7);
      },
    },
    723: {
      displayFn: (record: ReportRecord) => {
        return getTenants(record, 7);
      },
    },
    724: {
      displayFn: (record: ReportRecord) => {
        return getSelectedAvailability(record, 7);
      },
    },
    725: {
      displayFn: (record: ReportRecord) => {
        return getFloor(record, 8);
      },
    },
    726: {
      displayFn: (record: ReportRecord) => {
        return getTenants(record, 8);
      },
    },
    727: {
      displayFn: (record: ReportRecord) => {
        return getSelectedAvailability(record, 8);
      },
    },
  };
}
